import * as Types from '../../../gql/base-types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';

// =============================================================================
// Auto-generated by GraphQL Codegen - DO NOT EDIT
// Change the .gql source (or the schema) and re-run: pnpm codegen
// =============================================================================

const defaultOptions = {} as const;
export type GetReportingMoveAuditsQueryVariables = Types.Exact<{
  moveIds: Array<Types.Scalars['bigint']['input']> | Types.Scalars['bigint']['input'];
}>;


export type GetReportingMoveAuditsQuery = { __typename?: 'query_root', moveaudit: Array<{ __typename?: 'moveaudit', id: number, move_id: number, pickup_location_within_bounds: boolean, delivery_location_within_bounds: boolean, move_duration_within_bounds: boolean }> };


export const GetReportingMoveAuditsDocument = gql`
    query getReportingMoveAudits($moveIds: [bigint!]!) {
  moveaudit(where: {move_id: {_in: $moveIds}}) {
    id
    move_id
    pickup_location_within_bounds
    delivery_location_within_bounds
    move_duration_within_bounds
  }
}
    `;

/**
 * __useGetReportingMoveAuditsQuery__
 *
 * To run a query within a React component, call `useGetReportingMoveAuditsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReportingMoveAuditsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReportingMoveAuditsQuery({
 *   variables: {
 *      moveIds: // value for 'moveIds'
 *   },
 * });
 */
export function useGetReportingMoveAuditsQuery(baseOptions: Apollo.QueryHookOptions<GetReportingMoveAuditsQuery, GetReportingMoveAuditsQueryVariables> & ({ variables: GetReportingMoveAuditsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetReportingMoveAuditsQuery, GetReportingMoveAuditsQueryVariables>(GetReportingMoveAuditsDocument, options);
      }
export function useGetReportingMoveAuditsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetReportingMoveAuditsQuery, GetReportingMoveAuditsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetReportingMoveAuditsQuery, GetReportingMoveAuditsQueryVariables>(GetReportingMoveAuditsDocument, options);
        }
// @ts-ignore
export function useGetReportingMoveAuditsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetReportingMoveAuditsQuery, GetReportingMoveAuditsQueryVariables>): Apollo.UseSuspenseQueryResult<GetReportingMoveAuditsQuery, GetReportingMoveAuditsQueryVariables>;
export function useGetReportingMoveAuditsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetReportingMoveAuditsQuery, GetReportingMoveAuditsQueryVariables>): Apollo.UseSuspenseQueryResult<GetReportingMoveAuditsQuery | undefined, GetReportingMoveAuditsQueryVariables>;
export function useGetReportingMoveAuditsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetReportingMoveAuditsQuery, GetReportingMoveAuditsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetReportingMoveAuditsQuery, GetReportingMoveAuditsQueryVariables>(GetReportingMoveAuditsDocument, options);
        }
export type GetReportingMoveAuditsQueryHookResult = ReturnType<typeof useGetReportingMoveAuditsQuery>;
export type GetReportingMoveAuditsLazyQueryHookResult = ReturnType<typeof useGetReportingMoveAuditsLazyQuery>;
export type GetReportingMoveAuditsSuspenseQueryHookResult = ReturnType<typeof useGetReportingMoveAuditsSuspenseQuery>;
export type GetReportingMoveAuditsQueryResult = Apollo.QueryResult<GetReportingMoveAuditsQuery, GetReportingMoveAuditsQueryVariables>;
import { resolveExecutor, type GqlExecutor, type GqlRequestOptions } from '@hopdrive/sdk-core'


/**
 * @source {@link src/features/reporting/queries/getReportingMoveAudits.query.gql}
 */
export async function getReportingMoveAudits(
  variables: GetReportingMoveAuditsQueryVariables,
  options?: { executor?: GqlExecutor; raw?: false } & GqlRequestOptions
): Promise<GetReportingMoveAuditsQuery['moveaudit']>
export async function getReportingMoveAudits(
  variables: GetReportingMoveAuditsQueryVariables,
  options?: { executor?: GqlExecutor; raw: true } & GqlRequestOptions
): Promise<GetReportingMoveAuditsQuery>
export async function getReportingMoveAudits(
  variables: GetReportingMoveAuditsQueryVariables,
  options?: { executor?: GqlExecutor; raw?: boolean } & GqlRequestOptions
): Promise<GetReportingMoveAuditsQuery['moveaudit'] | GetReportingMoveAuditsQuery> {
  const { executor, raw, ...requestOptions } = options ?? {}
  const result = await resolveExecutor(executor).query<GetReportingMoveAuditsQuery>(
    GetReportingMoveAuditsDocument,
    variables,
    requestOptions
  )
  if (raw) return result
  return result.moveaudit
}